import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

import FormStepLayout from 'src/components/FormStepLayout';
import type { LocationMappingEditorFormStep } from 'src/pages/locationMapping/locationMappingEditor/LocationMappingEditorTypes';

import styles from './StepUpload.module.scss';

const FileUploaded: LocationMappingEditorFormStep<{
	inputFileName: string;
}> = ({ onContinue, inputFileName }) => {
	return (
		<FormStepLayout
			title="Location Mapping's File"
			subTitle=''
			onContinue={onContinue}
		>
			<div className={styles.upload}>
				<div className={styles.content}>
					<div className={styles['file-content-box']}>
						<InsertDriveFileIcon className={styles['drive-file-icon']} />
						<p className={styles['file-content-box-text']}>{inputFileName}</p>
					</div>
				</div>
			</div>
		</FormStepLayout>
	);
};

export default FileUploaded;
